import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogDescription,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogTrigger,
        DialogBody,
    } from '@/components/ui/dialog';
    import { Alert } from '@/components/ui/alert';
    import { computed, ref } from 'vue';
    import { Plus } from 'lucide-vue-next';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import FileUploadZone from '../FileUploadZone.vue';
    import Permission from '@/enums/Permission';
    import type { HolidayPayObligation } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UploadHolidayPayObligations',
  props: {
    holidayPayObligation: {},
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const { hasPermission } = usePermissions();

    const props = __props;

    const emit = __emit;

    const open = computed({
        get: () => props.modelValue ?? false,
        set: (value) => emit('update:modelValue', value),
    });

    const uploadedFile = ref([]);

    const { t } = useI18n();

    const handleSuccess = () => {
        toast.success(t('forms.general.success'));
    };

return (_ctx: any,_cache: any) => {
  return (_unref(hasPermission)(_unref(Permission).HOLIDAY_PAY_OBLIGATIONS_UPDATE))
    ? (_openBlock(), _createBlock(DataTableActions, {
        key: 0,
        data: _ctx.holidayPayObligation
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "xs",
                    width: "narrow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('forms.upload')) + " ", 1),
                      _createVNode(_unref(Plus), { class: "text-accent size-3" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogHeader), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('holiday-pay-obligations.upload')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogDescription), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('holiday-pay-obligations.file_headers_needed')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Alert), { variant: "warning" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('holiday-pay-obligations.file_import_warning')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(FileUploadZone, {
                        modelValue: uploadedFile.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uploadedFile).value = $event)),
                        "instant-upload": "",
                        "accepts-files": ['.xls', '.xlsx'],
                        route: 
                            _ctx.route('v2.salary.holiday-pay-obligations.upload', {
                                companyId: _ctx.holidayPayObligation.company_id,
                                id: _ctx.holidayPayObligation.payroll_id,
                            })
                        ,
                        "max-uploads": 1,
                        onSuccess: handleSuccess
                      }, null, 8, ["modelValue", "route"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogClose), { "as-child": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Button), {
                            variant: "outline",
                            size: "sm"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('forms.close')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]))
    : _createCommentVNode("", true)
}
}

})